import React from 'react';

const RelatorioPagamentos = () => {
  return (
    <div>
      <h2>Relatório de Pagamentos</h2>
      <p>Aqui você pode implementar o relatório de pagamentos.</p>
    </div>
  );
};

export default RelatorioPagamentos;
